(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-picker-15o5"] && !Shopify.designMode) return;
  try {
    
  class ScentPicker15o5 extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-scent-btn]'));
      this.syncEls = Array.from(this.querySelectorAll('[data-scent-sync]'));
      this.count = this.buttons.length
        ? Math.max(...this.buttons.map((btn) => Number(btn.dataset.index))) + 1
        : 0;
      this.activeIndex = 0;

      this.buttons.forEach((btn) => btn.addEventListener('click', this.onButtonClick.bind(this)));

      this.media = this.querySelector('.scent-picker-15o5__media');
      if (this.media) {
        this.media.addEventListener('pointerdown', this.onPointerDown.bind(this));
        this.media.addEventListener('pointerup', this.onPointerUp.bind(this));
        this.media.addEventListener('pointercancel', this.onPointerCancel.bind(this));
      }
    }

    onButtonClick(event) {
      this.activate(Number(event.currentTarget.dataset.index));
    }

    onPointerDown(event) {
      this.dragStartX = event.clientX;
      this.dragStartY = event.clientY;
    }

    onPointerUp(event) {
      if (this.dragStartX === undefined) return;
      const deltaX = event.clientX - this.dragStartX;
      const deltaY = event.clientY - this.dragStartY;
      this.dragStartX = undefined;

      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

      const direction = deltaX < 0 ? 1 : -1;
      const nextIndex = (this.activeIndex + direction + this.count) % this.count;
      this.activate(nextIndex);
    }

    onPointerCancel() {
      this.dragStartX = undefined;
    }

    activate(index) {
      if (index === this.activeIndex || !this.buttons.length) return;
      this.activeIndex = index;

      let accent = '';

      this.buttons.forEach((btn) => {
        const isActive = Number(btn.dataset.index) === index;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive && btn.style.getPropertyValue('--btn-accent-15o5')) {
          accent = btn.style.getPropertyValue('--btn-accent-15o5');
        }
        if (isActive && btn.style.getPropertyValue('--dot-accent-15o5')) {
          accent = btn.style.getPropertyValue('--dot-accent-15o5');
        }
      });

      if (accent) {
        this.style.setProperty('--scent-accent-15o5', accent);
      }

      this.syncEls.forEach((el) => {
        const isActive = Number(el.dataset.index) === index;
        el.classList.toggle('is-active', isActive);
        if (isActive) {
          el.removeAttribute('aria-hidden');
        } else {
          el.setAttribute('aria-hidden', 'true');
        }
        const cta = el.querySelector('[data-scent-cta]');
        if (cta) {
          if (isActive) {
            cta.removeAttribute('tabindex');
          } else {
            cta.setAttribute('tabindex', '-1');
          }
        }
      });
    }
  }

  if (!customElements.get('scent-picker-15o5')) {
    customElements.define('scent-picker-15o5', ScentPicker15o5);
  }

  } catch(e) { console.error(e); }
})();
})();
